import { render, staticRenderFns } from "./tatreport.vue?vue&type=template&id=cb3f05ba"
import script from "./tatreport.vue?vue&type=script&lang=js"
export * from "./tatreport.vue?vue&type=script&lang=js"
import style0 from "./tatreport.vue?vue&type=style&index=0&id=cb3f05ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports